import { styled } from '@mui/material/styles';

import Popover from 'src/components/Popover';

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'fixed',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',
}));

export const StyledPopover = styled(Popover)({
  '& .MuiPaper-root': {
    backgroundColor: '#111317',

    border: '0',
    borderRadius: '1.2rem',

    '& > div': {
      width: '30rem',
    },
  },
});

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.base07,

  padding: '3rem',

  position: 'relative',
}));

export const TopContainer = styled('div')({
  position: 'absolute',

  top: '2rem',
  right: '2rem',
});

export const BodyContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',

  alignItems: 'center',
});

export const BodySubTextContainer = styled('div')(({ theme }) => ({
  width: '20rem',

  marginTop: '1rem',

  color: '#BAC1C9',

  fontSize: '1.2rem',
  fontFamily: theme.typography.h9.fontFamily,

  textAlign: 'center',
}));

export const IconContainer = styled('div')({
  width: '3.2rem',
  height: '3.2rem',

  '& > svg': {
    width: '3.2rem',
    height: '3.2rem',
  },
});
